import { AppConfigs } from "@/app.configs";
import { InHouseTaskNames } from "./InHouseTaskNames";

interface Mapping {
  badgeName: string;
  image: string;
}

export interface IInHouseTaskMapping {
  [key: string]: Mapping;
}


export const InHouseTaskMapping: IInHouseTaskMapping = {
  [InHouseTaskNames.BONUS_REWARD]: { badgeName: "", image: AppConfigs.staticImages.BONUS },
  [InHouseTaskNames.VERIFY_PHONE]: { badgeName: "Verify", image: AppConfigs.staticImages.VERIFY },
  [InHouseTaskNames.INVITE_FRIENDS]: { badgeName:"", image: AppConfigs.staticImages.INVITEFRIENDS },
  [InHouseTaskNames.DAILY_CHECK_IN]: { badgeName: "", image: AppConfigs.staticImages.DAILYCHECKIN },
  [InHouseTaskNames.SHARE_FACEBOOK]: { badgeName: "Social", image: AppConfigs.staticImages.FACEBOOK },
  [InHouseTaskNames.SHARE_TWITTER]: { badgeName: "Social", image: AppConfigs.staticImages.SHAREONTWITTER },
  [InHouseTaskNames.SHARE_ACTIVITY]: { badgeName: "Social", image: AppConfigs.staticImages.SHAREACTIVITY },
  [InHouseTaskNames.COMPLETE_TUTORIAL]: { badgeName: "Tutorials", image: AppConfigs.staticImages.TUTORIAL },
  [InHouseTaskNames.CUSTOMER_FEEDBACK]: { badgeName: "Feedback", image: AppConfigs.staticImages.BONUS },
  [InHouseTaskNames.SHARE_WHATSAPP]: { badgeName: "Social", image: AppConfigs.staticImages.SHAREONWHATSAPP },
  [InHouseTaskNames.LIKE_US_FACEBOOK]: { badgeName: "Social", image: AppConfigs.staticImages.LIKEONFACEBOOK },
  [InHouseTaskNames.FOLLOW_US_TIKTOK]: { badgeName: "Social", image: AppConfigs.staticImages.FOLLOWONTIKTOK },
  [InHouseTaskNames.SHARE_INSTAGRAM]: { badgeName: "Social", image: AppConfigs.staticImages.SHAREONINSTAGRAM },
  [InHouseTaskNames.SHARE_MESSENGER]: { badgeName: "Social", image: AppConfigs.staticImages.SHAREONMESSENGER },
  [InHouseTaskNames.FOLLOW_US_TWITTER]: { badgeName: "Social", image: AppConfigs.staticImages.FOLLOWONTWITTER },
  [InHouseTaskNames.ENTER_REFERRAL]: { badgeName: "Referral", image: AppConfigs.staticImages.ENTERREFERRALCODE },
  [InHouseTaskNames.FOLLOW_US_FACEBOOK]: { badgeName: "Social", image: AppConfigs.staticImages.FOLLOWONFACEBOOK },
  [InHouseTaskNames.FOLLOW_US_INSTAGRAM]: { badgeName: "Social", image: AppConfigs.staticImages.FOLLOWONINSTAGRAM },
  [InHouseTaskNames.SPIN_THE_WHEEL]: { badgeName: "Spin the Wheel", image: AppConfigs.staticImages.SPINTHEWHEEL },
};
